export default "__VITE_ASSET__CNaQQl3i__"